import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoCotaDistribOrgao(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaocotadistriborgao/FIND_VISUACOTADISTRIBORGAO':
      case '@operacaocotadistriborgao/UPDATE_VISUACOTADISTRIBORGAO':
      case '@operacaocotadistriborgao/DELETE_VISUACOTADISTRIBORGAO':
      case '@operacaocotadistriborgao/STORE_VISUACOTADISTRIBORGAO':
      case '@operacaocotadistriborgao/VISUACOTADISTRIBORGAO_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaocotadistriborgao/SUCCESS_REMOVE':
      case '@operacaocotadistriborgao/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaocotadistriborgao/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaocotadistriborgao;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaocotadistriborgao/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaocotadistriborgao;
        break;
      }

      case '@operacaocotadistriborgao/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
